import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyledTable } from '$pages/serviceprovider/ReceivedRequests/styledComponents'
import createColumns from '$pages/serviceprovider/ReceivedRequests/createColumns'
import ExpandedForwardingRow from './ExpandedForwardingRow'
import { useOrderPartsListStatus } from '$components/OrderPartsListStatus'

const OperatorOrdersTable = ({
  orderPartLists,
  loading,
  pagination,
  handleTableChange,
}) => {
  const { t } = useTranslation()
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  const { determineStatus } = useOrderPartsListStatus()

  const onTableRowExpand = (expanded, record) => {
    const keys = []
    if (expanded) keys.push(record.id)
    setExpandedRowKeys(keys)
  }

  const columns = createColumns(t, null, {}, determineStatus, {}, {})

  return (
    <StyledTable
      columns={columns}
      loading={loading}
      dataSource={orderPartLists}
      rowKey={(data) => data.id}
      pagination={{
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showSizeChanger: true,
      }}
      onChange={handleTableChange}
      expandable={{
        showExpandColumn: true,
        expandRowByClick: true,
        expandedRowRender: (record) => (
          <ExpandedForwardingRow orderPartsList={record} />
        ),
        expandedRowKeys: expandedRowKeys,
        onExpand: onTableRowExpand,
      }}
    />
  )
}

export default OperatorOrdersTable
